interface Props {
  reason?: string;
}

export function BrowserWarning({ reason }: Props) {
  return (
    <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-xl">
      <div className="flex items-start gap-3">
        <span className="text-2xl">⚠️</span>
        <div>
          <h3 className="font-semibold text-amber-800">Browser Not Supported</h3>
          <p className="text-amber-700 text-sm mt-1">
            {reason || 'Your browser does not support the required features.'}
          </p>
          <p className="text-amber-600 text-sm mt-2">
            Please use <strong>Chrome</strong>, <strong>Firefox</strong>, or <strong>Edge</strong>.
          </p>
        </div>
      </div>
    </div>
  );
}
